import { TournamentState } from '@ps/web-poker-tile-mappers';
import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerSundayMillionWidget } from '../../../model';

import EventCountdown from './EventCountdown';
import EventTimer from './EventTimer';

const EventTime: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const state = useSelector(widgetSelect.getTournament)?.formattedState;
  switch (state) {
    case TournamentState.ANNOUNCED:
    case TournamentState.REGISTERING:
    case TournamentState.SEATING:
    case TournamentState.PAUSED:
    case TournamentState.LATE_REGISTRATION: {
      return <EventCountdown />;
    }
    case TournamentState.RUNNING:
      return <EventTimer />;
  }
  return null;
};

export default EventTime;
